import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MapLayer } from "../../components/VMRS/MapAdapter/layers/types";
import { MapType } from "../../components/VMRS/MapAdapter/types/MapTypes";
interface MapBaseSlice {
  basemaps: MapLayer[];
  selectedBasemap: MapLayer | undefined;
  engine: "2d" | "3d";

  view: {
    center: [number, number];
    zoom: number;
    bearing?: number;
    pitch?: number;
  };
  mousePosition: [number, number]; // lng lat
  mapType: MapType;
}
const initialState: MapBaseSlice = {
  basemaps: [],
  selectedBasemap: undefined,
  engine: "2d",

  view: {
    center: [105.8, 21.03],
    zoom: 5,
  },
  mousePosition: [105.8, 21.03],
  mapType: "maplibre",
};

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    switchEngine(state, action) {
      state.engine = action.payload;
    },
    setView(state, action) {
      state.view = action.payload;
    },
    setBasemapList(state, action: PayloadAction<MapLayer[]>) {
      state.basemaps = action?.payload;
    },
    changeMapType(state, action: PayloadAction<MapType>) {
      state.mapType = action.payload;
    },
    changeBasemap(state, action: PayloadAction<MapLayer | undefined>) {
      state.selectedBasemap = action?.payload;
    },
    changeMousePosition(state, action: PayloadAction<[number, number]>) {
      state.mousePosition = action.payload;
    },

  },
});

export const { switchEngine, setView, setBasemapList, changeMapType, changeBasemap, changeMousePosition } = mapSlice.actions;
export default mapSlice.reducer;
